export default {
  "mobile-container": "_mobile-container_15belj"
};
